
import { mapActions, mapState, mapGetters } from "vuex";
import NoDataLabel from "../common/no-data-label.vue";
import ReportOrderDetailsList from "./report-order-details-list.vue";
import ReportOrderFilter from "./report-order-filter.vue";
import ReportOrdersTableHeader from "./report-orders-table-header.vue";
import reportOrdersTableRow from "./report-orders-table-row.vue";
import { reportOrdersHeader } from "../../constants/Others";
export default {
  components: {
    reportOrdersTableRow,
    ReportOrderFilter,
    ReportOrdersTableHeader,
    NoDataLabel,
    ReportOrderDetailsList
  },
  props: {
    printMode: {
      default: false
    }
  },
  data() {
    return {
      LOAD_ORDERS_DELAY: 100,
      orderTimeout: 0,
      headers: reportOrdersHeader,

      printRownsInPage: 16,
      rowsOccupiedByHeader: 4,
      isLoading: true
    };
  },
  created() {
    this.$nuxt.$on("order-filter-changed", this.fetchOrderReport);
  },

  mounted() {
    this.fetchOrderReport();
  },
  computed: {
    ...mapState("report", [
      "ordersLoading",
      "reportOrders",
      "selectedOrderFilter"
    ]),
    ...mapGetters("report", ["getOrdersListReport"])
  },
  methods: {
    ...mapActions("report", ["getOrderReport"]),
    fetchOrderReport() {
      clearTimeout(this.orderTimeout);
      this.orderTimeout = setTimeout(
        (() => {
          this.getOrderReport({ backgroundLoad: false });
          this.isLoading = false;
        }).bind(this),
        this.LOAD_ORDERS_DELAY
      );
    },
    navigateToDetailPage(id) {
      this.$router.push(`/reciever/${id}`);
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("order-filter-changed");
  }
};
